import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RecentProjectsStoreService } from '../../../data-access/recent-projects/recent-projects-store.service';
import { RecentProjectsService } from '../../services/recent-projects/recent-projects.service';

@Injectable()
export abstract class RecentProjectsListServiceStrategy<T> {
  protected readonly store = inject(RecentProjectsStoreService);
  protected readonly recentProjectsService = inject(RecentProjectsService);

  abstract selectProject(project: T): void;

  abstract loadEnrichedProjects(): Observable<T[]>;
}
